import { useTranslation } from 'react-i18next';

const STYLES = {
  PENDING: 'bg-amber-500/20 text-amber-300',
  ACCEPTED: 'bg-emerald-500/20 text-emerald-300',
  REJECTED: 'bg-red-500/20 text-red-300',
};

const StaffAssignmentBadge = ({ status }) => {
  const { t } = useTranslation();

  if (!status) return null;

  const label = t(`status.appointmentAssignment.${status}`, { defaultValue: status });

  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${STYLES[status] || STYLES.PENDING}`}>
      {label}
    </span>
  );
};

export default StaffAssignmentBadge;
